module.exports = __webpack_public_path__ + "res/4-img_game_bg_q_t.06f12a537ebb40e7ebf9bdab03af45ca.png";